import React from 'react';
import TextBadge from '../TextBadge';
import styles from './HtmlContentBadge.module.less';

const HtmlContentBadge = ({ ecmContent }) => {
  const { badge = '', content = '' } = ecmContent || {};
  return (
    <div className={styles.container}>
      <TextBadge className={styles.badge} text={badge} />
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default HtmlContentBadge;
